import { render, staticRenderFns } from "./ActionWaitingLater.vue?vue&type=template&id=0b188078&"
import script from "./ActionWaitingLater.vue?vue&type=script&lang=js&"
export * from "./ActionWaitingLater.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports